import React from "react";
import calenderIcon from "../../assets/CalendarDots.png";
import Tippy from "@tippyjs/react";
import dateFormat from "dateformat";
import { getIncentiveStatusColor, reduceLongName } from "../../ReusableFunctions/reusableFunctions";
import { BES_INCENTIVE_STATUS } from "../../appConstants";
export default function IncentiveDetailsCard({
  handleClick,
  incentive,
  selectedIncentive,

}) {
  return (
    <div
      onClick={() => {
         handleClick(incentive);
      }}
      className={`
        cursor-pointer
          ${
      selectedIncentive?.id === incentive.id
        ? "border-[4px] border-l-[#0F5EFF]"
        : ""
    }
         transition-all duration-200 ease-in-out transform  w-full min-h-[80px] border-t-[1px] border-b-[1px]  border-t-[#D9D9D9] border-b-[#D9D9D9]`}
    >
      <div className="py-[0.8rem]  pl-6 pr-5 flex flex-col gap-[2px] text-[14px]">
        <div className="w-full flex justify-between">
          <span className="text-[14px] font-[700] text-[#1E1E1E] font-manrope ">
            {incentive?.bes_name || '-'}
          </span>
          <div className="min-w-[75px] text-[12px] gap-[4px] justify-center px-1 py-1 flex items-center bg-[#D9D9D9] rounded-[20px]">
            <img src={calenderIcon} alt="request-date" />
            <span className="mt-[1px]">
             {dateFormat(incentive?.date_added, "dd mmm")}
            </span>
          </div>
        </div>
        <div className="flex gap-[2px] items-center">
          <span className="mt-[0.5px]">Order No.</span>
          <span className="text-[#1E1E1E] text-[14px] font-[700] font-manrope ">
           {incentive?.order_number?`# ${incentive?.order_number}`:"-"}
          </span>
        </div>
        <Tippy content={incentive?.field_address}>
        <span className="font-[400] text-[13px] text-[#3B3B3B] font-manrope ">
           {reduceLongName( incentive?.field_address || "-",80)}
        </span>
        </Tippy>
        <div className="flex w-full justify-between items-center py-1">
          <div className="flex gap-1 text-[16px] font-manrope items-center font-[500]">
            <span className="text-[15px] text-[700] font-manrope text-[#0F5EFF] ">
              <span className="mr-[2px]">
                ₹
              </span>
             {incentive?.amount ||"-"}
            </span>
          </div>
          <div
            style={{
               color: getIncentiveStatusColor(incentive?.status, true),
              }}
            className={`font-[700]  text-[13px]`}
          >
           {incentive?.status===BES_INCENTIVE_STATUS.SUBMITTED?"Paid":incentive?.status || "-"}
          </div>
        </div>
      </div>
    </div>
  );
}
